import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";
import {
  buttonVariants,
  type ButtonSize,
  type ButtonVariant,
} from "./Button";

export interface LinkButtonProps extends LinkProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

/**
 * A react-router `<Link>` styled exactly like a Button.
 *
 * Use this instead of nesting `<Link><Button/></Link>` — nesting an
 * interactive `<button>` inside an `<a>` is invalid HTML and creates two
 * tab stops for one action.
 */
const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ className, variant = "primary", size = "md", children, ...props }, ref) => {
    return (
      <Link
        ref={ref}
        className={buttonVariants({ variant, size, className })}
        {...props}
      >
        {children}
      </Link>
    );
  }
);

LinkButton.displayName = "LinkButton";

export { LinkButton };
